/* =============================================================
   OrderModalContext — Global context for opening the OrderModal
   from anywhere in the app (Header, AIChatbot, CountryPage, etc.)
   ============================================================= */
import { createContext, useContext, useState, type ReactNode } from "react";
import OrderModal from "@/components/OrderModal";

export type OpenOrderModal = (visaKey?: string) => void;

const OrderModalContext = createContext<OpenOrderModal>(() => {});

export function useOrderModal() {
  return useContext(OrderModalContext);
}

export function OrderModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [preselectedVisaKey, setPreselectedVisaKey] = useState<string | undefined>(undefined);

  const openOrder: OpenOrderModal = (visaKey) => {
    setPreselectedVisaKey(visaKey);
    setIsOpen(true);
  };

  return (
    <OrderModalContext.Provider value={openOrder}>
      {children}
      <OrderModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        preselectedVisaKey={preselectedVisaKey}
      />
    </OrderModalContext.Provider>
  );
}
